__turbopack_context__.v({
  "header": "_66QwW_header",
  "quoteCitation": "_66QwW_quoteCitation",
  "quoteLink": "_66QwW_quoteLink",
  "quoteText": "_66QwW_quoteText",
  "quotes": "_66QwW_quotes",
  "quotesModule": "_66QwW_quotesModule",
});
